import Select from "../../../common/select";
import { useAppSelector } from "../../../../store/hooks/StoreHooks";
import useCollapseFacade from "../../../../facade/collapse.Facade";
import Accordion from "../../../common/accordion";
import useProtectorFacade from "../../../../facade/calculation/calculation-output/protector.facade";
import { useEffect, useState } from "react";
import { ProtectorListProps } from "../../../../store/model/calculations/protector";

const ProtectorCalculations: React.FC<ProtectorListProps> = ({ showError, setShowError }) => {

    const [bearingType, setBearingType] = useState<any[]>([]);
    const [shaftType, setShaftType] = useState<any[]>([]);
    const { protectorCalculationsCollapse } = useAppSelector((state) => state?.collapse);
    const { tab1Input } = useAppSelector((state) => state.tubing);
    const { motor_HPInput } = useAppSelector((state) => state.motor);
    const {
        bearingTypeList,
        shaftTypeList,
        thrustPercentage,
        protectorCalculations,
        shaftRatingValue,
        shaftPercentate,
        selectedLowerProtector
    } = useAppSelector((state) => state.protector);

    const { updateProtectorCalculationsCollapse } = useCollapseFacade();
    const { loadProtectorCalculations, loadProtectorCalculation, updateShaftRatingValue } = useProtectorFacade();

    useEffect(() => {
        if (+thrustPercentage > 100) {
            if (!showError?.includes("Force on thrust bearing exceds max load limit"))
                setShowError((prevState: any) => [...prevState, "Force on thrust bearing exceds max load limit"]);
        } else {
            setShowError((prevState: any) =>
                prevState.filter((error: any) => error !== "Force on thrust bearing exceds max load limit")
            );
        }
        if (+shaftPercentate > 100) {
            if (!showError?.includes("Protector shaft not suitable for required power"))
                setShowError((prevState: any) => [...prevState, "Protector shaft not suitable for required power"]);
        } else {
            setShowError((prevState: any) =>
                prevState.filter((error: any) => error !== "Protector shaft not suitable for required power")
            );
        }
    }, [thrustPercentage, shaftPercentate])

    useEffect(() => {
        let bearList: { value: string; label: string }[] = Object.entries(bearingTypeList || [])
            .map(([key, value]) => ({ value: value as string, label: key }))
        let shaftList: { value: string; label: string }[] = Object.entries(shaftTypeList || [])
            .map(([key, value]) => ({ value: value as string, label: key }))
        setBearingType(bearList);
        setShaftType(shaftList);
        loadProtectorCalculation();
    }, [bearingTypeList, shaftTypeList])

    const handleCollapseChange = (key: boolean) => {
        updateProtectorCalculationsCollapse(key);
    };

    const handleSelect = (option: any, name: any) => {
        loadProtectorCalculations(option?.value, name);
        if (name === "shaftType") {
            const shaftTypeValue = option?.value;
            const lowerProtectorValue = shaftTypeValue == 0 
                ? selectedLowerProtector?.stdShaftHP 
                : selectedLowerProtector?.hsShaftHP;
            if (lowerProtectorValue === 0 || lowerProtectorValue === null || lowerProtectorValue === undefined) {
                updateShaftRatingValue(0);
            }
        }
    };

    return (
        <Accordion
            title="Protector calculations"
            tooltipText="Formulas"
            link={'/help?tab=Protector#Protc'}
            isOpen={protectorCalculationsCollapse}
            onToggle={() => handleCollapseChange(!protectorCalculationsCollapse)}
            content={
                <div className="p-[16px] flex flex-col">
                    <div className="grid sm:grid-cols-2 grid-cols-1 gap-[16px]">
                        <div className="flex flex-col">
                            <label className="text-[18px] font-semibold text-white mb-[12px]">
                                Load Check
                            </label>
                            <div className="flex w-full rounded-[8px] flex-col border-[1px] border-darkcolor-400">
                                <div className="flex justify-between items-center px-[24px] py-[6.45px] border-b-[1px] border-b-darkcolor-400">
                                    <p className="text-white text-[14px]">Bearing Type</p>
                                    <Select
                                        options={bearingType || []}
                                        onChange={handleSelect}
                                        padding="px-[14px] py-[5px]"
                                        fontSize="16px"
                                        className="sm:px-0 px-[10px] w-[224px]"
                                        selectedValue={tab1Input?.hdnProtector_BearingType}
                                        name={"bearingType"}
                                    />
                                </div>
                                <div className="flex justify-between items-center px-[24px] py-[14px] border-b-[1px] border-b-darkcolor-400">
                                    <p className="text-white text-[14px]">Force On Thrust Bearing</p>
                                    <p className="text-white text-[14px]">{`${protectorCalculations?.[0] || 0}  ${tab1Input?.actNameProtector_CThrustForce || 'lb'}`}</p>
                                </div>
                                <div className="flex justify-between items-center px-[24px] py-[14px] border-b-[1px] border-b-darkcolor-400">
                                    <p className="text-white text-[14px]">Thrust Bearing Max. Load</p>
                                    <p className="text-white text-[14px]">{`${protectorCalculations?.[1] || 0} ${tab1Input?.actNameProtector_CMaxLoad || 'lb'}`}</p>
                                </div>
                                <div className="flex justify-between items-center px-[24px] py-[14px]">
                                    <p className="text-white text-[14px]">
                                        Percent Thrust Bearing Load
                                    </p>
                                    <p className="text-white text-[14px]">{`${thrustPercentage} %`}</p>
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-col">
                            <label className="text-[18px] font-semibold text-white mb-[12px]">
                                Shaft rating check
                            </label>
                            <div className="flex w-full rounded-[8px] flex-col border-[1px] border-darkcolor-400">
                                <div className="flex justify-between items-center px-[24px] py-[6.45px] border-b-[1px] border-b-darkcolor-400">
                                    <p className="text-white text-[14px]">Shaft Type</p>
                                    <Select
                                        options={shaftType || []}
                                        onChange={handleSelect}
                                        padding="px-[14px] py-[5px]"
                                        fontSize="16px"
                                        className="sm:px-0 px-[10px] w-[224px]"
                                        selectedValue={tab1Input?.hdnProtector_ShaftType}
                                        name={"shaftType"}
                                    />
                                </div>
                                {
                                    tab1Input?.hdnProtector_ShaftType == 0 ?
                                        <div className="flex justify-between items-center px-[24px] py-[14px] border-b-[1px] border-b-darkcolor-400">
                                            <p className="text-white text-[14px]">Protector Std. shaft rating</p>
                                            <p className="text-white text-[14px]">{shaftRatingValue} {tab1Input?.actNameProtector_THSShaftHP}</p>
                                        </div> :
                                        <div className="flex justify-between items-center px-[24px] py-[14px] border-b-[1px] border-b-darkcolor-400">
                                            <p className="text-white text-[14px]">Protector HS shaft rating</p>
                                            <p className="text-white text-[14px]">{shaftRatingValue} {tab1Input?.actNameProtector_THSShaftHP}</p>
                                        </div>
                                }
                                <div className="flex justify-between items-center px-[24px] py-[14px] border-b-[1px] border-b-darkcolor-400">
                                    <p className="text-white text-[14px]">Total BHP</p>
                                    <p className="text-white text-[14px]">{motor_HPInput} {tab1Input?.actNameMotor_HP}</p>
                                </div>
                                <div className="flex justify-between items-center px-[24px] py-[14px]">
                                    <p className="text-white text-[14px]">
                                        Percent of Protector Shaft Load
                                    </p>
                                    <p className="text-white text-[14px]">{shaftPercentate} %</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        />
    );
};

export default ProtectorCalculations;
